module.exports = __webpack_public_path__ + "media/images/Amsale-LWD-81299b92.webp";